import React, { useState } from 'react';
import Dropdown from 'react/elements/Dropdown';
import VerticalDots from 'react/elements/VerticalDots';

/**
 * The vertical-dots menu used on groups and idea rows, with the same mechanics as
 * `GroceryListItemEditDropdown`. `id` must be unique on the page: an idea in two groups has two rows.
 */
export default function OptionsMenu({ id, items }) {
	const [trigger, setTrigger] = useState(null);
	const [opened, setOpened] = useState(false);

	return (
		<div className='list_options'>
			<VerticalDots
				className='clickable'
				data-target={id}
				onClick={() => setOpened(true)}
				ref={setTrigger}
			/>
			<Dropdown
				id={id}
				opened={opened}
				attachTo={trigger}
				constrainWidth={false}
				items={items}
			/>
		</div>
	);
}
